import {
  Button,
  Form,
  FormLayout,
  TextField
} from '@superops/ui-design-system';
import envConfig from '@nile/home/src/Config/env';
import { emailValidator } from '@nile/components/src/Validators/fields';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  getErrorData,
  toast,
  getCookieValue,
  validateForm,
  getHeaderValue,
  fetchApi,
  useURLSearchParams,
  getURLSearchParams
} from '@nile/components';

import styled from 'styled-components';
import { TextStyle } from '@superops/ui-design-system';
import { isEmpty } from 'lodash';

const ForgotPasswordParent = styled.div`
  .reset-btn {
    margin-top: 40px;
  }

  .success-header {
    font-size: 20px;
    color: #518f10;
    font-weight: 500;
  }

  .success-message {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 500;
    margin-top: 8px;
  }

  .success-icon-block {
    display: flex;
    align-items: center;
    margin-right: 12px;
  }
`;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [tenantid, setTenantid] = useState('');

  const [showSuccessMessage, SetShowSuccessMessage] = useState(false);

  const [submitActionLoading, setSubmitActionLoading] = useState(false);

  const [serverError, setServerError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let validationError = validateForm(
      { email: email },
      { email: emailValidator({ mandatory: true }) }
    );
    if (validationError) {
      setError(validationError);
      return;
    }
    setServerError(null);
    const formData = new FormData();
    formData.append('email', email.trim());
    const requestOptions = {
      method: 'POST',
      body: formData,
      headers: getHeaderValue(),
      credentials: 'include'
    };
    if (email) {
      setSubmitActionLoading(true);
      const response = await fetchApi(
        `${envConfig.loginRoot}/user/forgotpassword`,
        requestOptions
      );
      if (!response.ok) {
        setServerError(getErrorData(response.status));
        setSubmitActionLoading(false);
        return;
      }
      setSubmitActionLoading(false);
      if (response.status === 200) {
        SetShowSuccessMessage(true);
      }

      if (response.status !== 200) {
        toast('error', 'Something went wrong');
      }
    }
  };

  const handleTenantChange = useCallback((value) => {
    setTenantid(value);
  }, []);

  const handleEmailChange = useCallback((value) => {
    setEmail(value);
  }, []);

  useEffect(() => {
    const emailFromQuery = getURLSearchParams().get('email');
    if (!isEmpty(emailFromQuery)) {
      setEmail(decodeURIComponent(emailFromQuery));
    }
  }, []);

  return (
    <ForgotPasswordParent>
      {showSuccessMessage ? (
        <div className="password-success-parent flex-row">
          <div>
            <div className="success-header">
              <FormattedMessage id="app.label.success" />
            </div>
            <div className="success-message">
              <FormattedMessage id="common.forgot.password.success.message" />
            </div>
          </div>
        </div>
      ) : (
        <Form onSubmit={handleSubmit}>
          <FormLayout>
            {/* <TextField
              value={tenantid}
              id="tenentid"
              onChange={handleTenantChange}
              label="Account ID"
              type="text"
              name="tenantid"
            />
            <br /> */}
            {serverError && (
              <>
                {serverError}
                <br />
              </>
            )}
            <TextField
              value={email}
              id="email"
              onChange={handleEmailChange}
              label={<FormattedMessage id="product.userLogin.email.label" />}
              type="email"
              name="email"
              error={
                error &&
                error.email && (
                  <FormattedMessage id="common.forgot.password.invalid.message" />
                )
              }
            />

            <div className="reset-btn">
              <Button
                primary
                onClick={handleSubmit}
                id="forgotPwdBtn"
                loading={submitActionLoading}
              >
                <FormattedMessage id="app.reset.password.link" />
              </Button>
            </div>
          </FormLayout>
        </Form>
      )}
    </ForgotPasswordParent>
  );
};

export default ForgotPasswordPage;
